import React from 'react';
import { Moment } from 'moment';
import CalendarAbsenceEvent from './CalendarAbsenceEvent';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { EventClickArg } from '@fullcalendar/react';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	selectedDate: Moment;
	workplaceId: string;
	event?: EventClickArg;
}

const CalendarAbsenceEventModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title={props.event ? 'base.editAbsence' : 'base.createAbsence'}
			size={Size.MD}>
			<CalendarAbsenceEvent
				selectedDate={props.selectedDate}
				workplaceId={props.workplaceId}
				event={props.event}
				onSuccess={props.onClose}
			/>
		</BaseModal>
	);
};

export default CalendarAbsenceEventModal;
